import { createSlice } from '@reduxjs/toolkit';

// Default theme configuration (fallback)
const defaultTheme = {
    primaryColor: '#ff670a', // vermilion-500
    logoUrl: null,
    fontStyle: 'Inter',
};

const initialState = {
    // Hotel-specific theme
    hotelTheme: null,
    // Applied theme (hotel theme or default)
    appliedTheme: defaultTheme,
    // Loading state
    isLoading: false,
    error: null,
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setHotelTheme: (state, action) => {
            state.hotelTheme = action.payload;
            // Apply hotel theme if it has a primary color, otherwise use default
            state.appliedTheme = {
                primaryColor: action.payload?.primaryColor || defaultTheme.primaryColor,
                logoUrl: action.payload?.logoUrl || defaultTheme.logoUrl,
                fontStyle: action.payload?.fontStyle || defaultTheme.fontStyle,
            };
            state.error = null;
        },
        resetTheme: (state) => {
            state.hotelTheme = null;
            state.appliedTheme = defaultTheme;
            state.error = null;
        },
        setThemeLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setThemeError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
    },
});

export const {
    setHotelTheme,
    resetTheme,
    setThemeLoading,
    setThemeError,
} = themeSlice.actions;

export default themeSlice.reducer;

// Selectors
export const selectAppliedTheme = (state) => state.theme.appliedTheme;
export const selectHotelTheme = (state) => state.theme.hotelTheme;
export const selectThemeLoading = (state) => state.theme.isLoading;
export const selectThemeError = (state) => state.theme.error;
